import { ILocale } from '../models/ILocale';
import { locales } from './locales';

export const defaultLocale: ILocale = locales[0];

export function isDefaultLocale(locale: ILocale) {
	return locale.code === defaultLocale.code;
}
